// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16IMT","title":"styles_title__1TOMU"};